{
  "header": {
    "title": "Profil",
    "description": "Verwalten Sie Ihr Benutzerkonto"
  },
  "tabs": {
    "settings": {
      "label": "Einstellungen",
      "saveChangeButton": "Änderungen speichern",
      "photoSection": {
        "title": "Foto",
        "changePhotoButton": "Foto ändern",
        "maxSize": "Max. 5 MB",
        "format": "PNG-, JPG-Format"
      },
      "personalInformationSection": {
        "title": "Persönliche Informationen",
        "nonEditable": {
          "nameInput": { "label": "Name" },
          "jobTitleInput": { "label": "Berufsbezeichnung" },
          "managerNameInput": { "label": "Name des Vorgesetzten" },
          "userRoleInput": { "label": "Benutzerrolle" },
          "emailInput": { "label": "E-Mail" },
          "departmentInput": { "label": "Abteilung" },
          "tenureInput": { "label": "Dienstzeit" }
        },
        "editable": {
          "languageInput": { "label": "Sprache" },
          "dateFormatInput": { "label": "Datumsformat" },
          "locationInput": { "label": "Standort" },
          "timeZoneInput": { "label": "Zeitzone" }
        }
      },
      "emailPreferencesSection": {
        "weeklyDigest": "Wöchentliche Zusammenfassung per E-Mail senden",
        "monthlyDigest": "Monatliche Zusammenfassung mit Ihren Erkenntnissen senden"
      }
    },
    "directReports": {
      "label": "Meine direkten Mitarbeiter",
      "emptyState": {
        "title": "Keine direkten Mitarbeiter",
        "description": "Ihnen sind noch keine direkten Mitarbeiter zugewiesen. Sobald Personen Ihnen unterstellt sind, erscheinen sie hier."
      },
      "error": {
        "title": "Direkte Mitarbeiter konnten nicht geladen werden",
        "description": "Beim Laden Ihrer direkten Mitarbeiter ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
        "retry": "Erneut versuchen"
      }
    }
  }
}
